import { Alert, Icon } from '@inflearn/ds-react-next';
import { faCircleExclamation } from '@inflearn/pro-solid-svg-icons';
import { useTranslation } from 'next-i18next';

interface LeaveModalAlertProps {
  hasRemainSettlementAmount: boolean;
  hasPassword: boolean;
}

const LeaveModalAlertContent = ({
  hasRemainSettlementAmount,
  hasPassword,
}: LeaveModalAlertProps) => {
  const { t } = useTranslation();
  if (hasRemainSettlementAmount) {
    return (
      <>
        내용을 모두 확인하셨나요?
        <br />
        탈퇴 신청서를 작성하면 위 내용에 동의하는 것으로 간주됩니다.
      </>
    );
  }

  if (hasPassword) {
    return (
      <>
        {t('내용을 모두 확인하셨나요?')}
        <br />
        {t('비밀번호를 입력 후, 탈퇴하면 위 내용에 동의하는 것으로 간주됩니다.')}
      </>
    );
  }

  return (
    <>
      {t('탈퇴를 진행하기 위해 먼저 비밀번호 발급이 필요합니다.')}
      <br />
      {t('비밀번호 발급 후, 재시도해주세요.')}
    </>
  );
};

export const LeaveModalAlert = ({
  hasRemainSettlementAmount,
  hasPassword,
}: LeaveModalAlertProps) => {
  const { t } = useTranslation();

  return (
    <Alert
      mt={20}
      icon={<Icon icon={faCircleExclamation} />}
      title={t('탈퇴 시, 위 혜택이 모두 사라집니다.')}
      variant="light"
      type="error"
    >
      <LeaveModalAlertContent
        hasRemainSettlementAmount={hasRemainSettlementAmount}
        hasPassword={hasPassword}
      />
    </Alert>
  );
};
